interface ColumnItem {
  columnKey: string;
  isGrouped?: boolean;
  aggregationType?: string | null;
  aggregateColumn?: string | null;
  columnGroupKey?: string | null;
  bucketType?: string | null;
  bucketConfig?: unknown;
  order?: string | null;
}

interface MetricDataItem {
  columnKey: string;
  aggregationType: string | null | undefined;
  aggregateColumn: string | null | undefined;
  columnGroupKey: string | null | undefined;
}

interface GroupItem {
  columnKey: string;
  aggregateColumn?: string | null;
  bucketType?: string | null;
  bucketConfig?: unknown;
  columnGroupKey?: string | null;
  aggregationType?: string | null;
}

interface GroupColumnDataResult {
  groupColumn: ColumnItem | null;
  groupColumns: ColumnItem[];
  metricData: MetricDataItem[];
  groups: GroupItem[];
  allGroupColumns: ColumnItem[];
}

const getGroupColumnData = (visisbledColumns: ColumnItem[]): GroupColumnDataResult => {
  // find any count/avg/min/max columns are visible
  let allGroupColumns: ColumnItem[] = [],
    groupColumn: ColumnItem | null = null,
    groupColumns: ColumnItem[] = [], // Support multiple group columns
    groups: GroupItem[] = [],
    metricData: MetricDataItem[] = [];

  // Find all grouped columns (not just the first one)
  // Only columns marked as isGrouped, NOT metric columns (which have columnGroupKey but not isGrouped)
  groupColumns = visisbledColumns.filter((item) => item.isGrouped);

  // Keep groupColumn for backwards compatibility (first group)
  groupColumn = groupColumns.length > 0 ? groupColumns[0] : null;

  if (groupColumns.length > 0) {
    const metricColumns = visisbledColumns.filter((item) => item.aggregationType);

    allGroupColumns = [...groupColumns, ...metricColumns];

    metricData = metricColumns.map((item) => {
      return {
        columnKey: item.columnKey,
        aggregationType: item.aggregationType,
        aggregateColumn: item.aggregateColumn,
        columnGroupKey: item.columnGroupKey, // columnKey of group Column
      };
    });

    // Add all group columns to groups array
    groups = [
      ...groupColumns.map((gc) => ({
        columnKey: gc.columnKey,
        aggregateColumn: gc.aggregateColumn,
        bucketType: gc.bucketType,
        bucketConfig: gc.bucketConfig,
        columnGroupKey: gc.columnKey,
      })),
      ...metricData,
    ];
  }

  return {
    groupColumn, // the first groupColumn (for backwards compatibility)
    groupColumns, // all group columns
    metricData, // count/min/max/avg,..
    groups, // data store in backend
    allGroupColumns, // contain group column(s), and metric columns
  };
};

export { getGroupColumnData };
export type { ColumnItem, MetricDataItem, GroupItem, GroupColumnDataResult };
